import React, { Component, Fragment } from "react";
import ThisTable from "../../../Common/ThisTable";
import { getLoggedInUser } from "../../../MainPage/UserInfo";
import { ButtonActionsTable, ButtonCirclePlus } from "../../../Common/Buttons";
import { MyButton } from "../../../Common/Forms/formsMiscItems";
import { languageService } from "../../../../Language/language.service";
import "./styles.css";
import ConfirmationDialog from "../../../../libraries/ConfirmationDialog";
import { siteNotesFormSchema } from "./siteNotesFormSchema";
import { updateShortSchema } from "../../../../libraries/form/schemaInterpreter";
import CustomForm from "../../../../libraries/form";
import _ from "lodash";
import { dataFormatters } from "../../../../utils/dataFormatters";
import moment from "moment";
import { guid } from "utils/UUID";

const user = getLoggedInUser();

class SiteNotes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showForm: false,
      siteNotesFormSchema: updateShortSchema(_.cloneDeep(siteNotesFormSchema)),
      siteNotesFormState: "create",
      editMode: false,
      openAddEditSiteNotesForm: false,
      openAddEditSiteNotesFormData: {},
      confirmationDialog: null,
      selectedNoteData: null,
      notesData: [],
      testSchedule: null,
    };
    this.isUserAllowed = props.allowedUsers ? props.allowedUsers.includes(user.group_id) : [];
    this.handleAddEditDelete = this.handleAddEditDelete.bind(this);
    this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);
    this.openConfirmationDialog = this.openConfirmationDialog.bind(this);
    this.deleteSiteNote = this.deleteSiteNote.bind(this);
    this.addSiteNote = this.addSiteNote.bind(this);
    this.updateSiteNote = this.updateSiteNote.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.getTableColumns = this.getTableColumns.bind(this);
    this.setTestScheduleData = this.setTestScheduleData.bind(this);
  }
  componentDidMount() {
    this.setTestScheduleData(this.props.testSchedule);
  }

  componentDidUpdate(prevProps) {
    let condition = _.isEqual(prevProps.testSchedule, this.props.testSchedule);
    if (!condition) {
      this.setTestScheduleData(this.props.testSchedule);
    }
  }

  setTestScheduleData() {
    let notesData = [];
    let testScheduleGroup = [];
    let testScheduleWithNotes = this.props.testSchedule.find(
      (test) =>
        test.otherInfo &&
        test.otherInfo.supervisorNotes &&
        test.otherInfo.supervisorNotes.length > 0 &&
        test.otherInfo.supervisorNotes[0].note,
    );
    if (testScheduleWithNotes) {
      notesData = testScheduleWithNotes.otherInfo.supervisorNotes;
      testScheduleGroup = this.props.testSchedule.filter((test) => test._id.toString() !== testScheduleWithNotes._id.toString());
    } else {
      testScheduleWithNotes = this.props.testSchedule[0];
      testScheduleGroup = this.props.testSchedule.slice(1);
    }
    this.setState({
      testSchedule: testScheduleWithNotes ? testScheduleWithNotes : this.props.testSchedule[0],
      notesData: notesData,
      testScheduleGroup: testScheduleGroup.map((test) => test._id),
    });
  }

  getTableColumns(getActions) {
    let columns = [
      {
        Header: languageService("Note"),
        accessor: "note",
        id: "note",
        style: { whiteSpace: "unset" },
        minWidth: 160,
      },

      {
        Header: languageService("User"),
        id: "user",
        accessor: "user.userName",
        style: { whiteSpace: "unset" },
        minWidth: 80,
      },

      {
        Header: languageService("Date & Time"),
        id: "date",
        accessor: (d) => moment(d.date).format("MM/DD/YYYY h:mm A"),
        style: { whiteSpace: "unset" },

        minWidth: 80,
      },
    ];

    getActions &&
      columns.push({
        Header: languageService("Actions"),
        id: "actions",
        minWidth: 50,
        filterable: false,
        accessor: (d) => {
          return (
            d.user.email === user.email && (
              <div>
                <ButtonActionsTable
                  handleClick={() => {
                    this.handleAddEditDelete("Edit", d);
                  }}
                  margin="0px 10px 0px 0px"
                  buttonText={languageService("Edit")}
                />

                <ButtonActionsTable
                  handleClick={() => {
                    this.handleAddEditDelete("Delete", d);
                  }}
                  margin="0px 10px 0px 0px"
                  buttonText={languageService("Delete")}
                />
              </div>
            )
          );
        },
      });

    return columns;
  }

  handleAddEditDelete(action, data) {
    const editState = () =>
      this.setState({
        openAddEditSiteNotesForm: true,
        siteNotesFormState: "edit",
        openAddEditSiteNotesFormData: data,
        selectedNoteData: data,
      });

    const createState = () => {
      this.addSiteNote();
    };

    const deleteState = () => {
      this.setState({
        selectedNoteData: data,
      });
      this.openConfirmationDialog(
        `Confirm Delete`,
        `Are you sure you want to delete?`,
        null,

        "ConfirmDelete",
        this.handleAddEditDelete,
      );
    };

    const confirmDeleteState = () => {
      this.deleteSiteNote();
      this.closeConfirmationDialog();
    };

    const key = {
      Edit: editState,

      Create: createState,

      Delete: deleteState,

      ConfirmDelete: confirmDeleteState,
    };

    key[action]();
  }

  closeConfirmationDialog() {
    this.setState({
      confirmationDialog: null,
    });
  }

  openConfirmationDialog(title, message, displayAddInfo, action, confirmCallback) {
    this.setState({
      confirmationDialog: (
        <ConfirmationDialog
          title={title}
          body={
            <Fragment>
              <div>{`${message}`}</div>
              {displayAddInfo}
            </Fragment>
          }
          action={action}
          cancelCallback={this.closeConfirmationDialog}
          confirmationCallback={confirmCallback}
        />
      ),
    });
  }

  addSiteNote() {
    const noteValue = "Reviewed";
    const { notesData, testSchedule, testScheduleGroup } = this.state;

    let newId = guid();
    let newNoteDataObj = {
      id: newId,
      note: noteValue,
      date: new Date(),
      user: { userName: user.name, groupId: user.group_id, email: user.email },
    };

    let newNotesData = [...notesData, newNoteDataObj];

    let dataObj = {
      _id: testSchedule._id,
      groupIds: testScheduleGroup,
      otherInfo: {
        ...testSchedule.otherInfo,
        supervisorNotes: newNotesData,
      },
    };

    this.props.updateTestSchedule(dataObj, "updateSiteNote");
    this.closeDialog();
  }
  updateSiteNote(data) {
    const noteValue = data.fields["note"];
    const { notesData, testSchedule, selectedNoteData, testScheduleGroup } = this.state;
    let foundNoteIndex = notesData.findIndex((d) => d.id === selectedNoteData.id);

    let newNoteDataObj = {
      id: notesData[foundNoteIndex].id,
      note: noteValue,
      date: new Date(),
      user: { userName: user.name, groupId: user.group_id, email: user.email },
    };

    let newNotesData = notesData;
    newNotesData[foundNoteIndex] = newNoteDataObj;

    let dataObj = {
      _id: testSchedule._id,
      groupIds: testScheduleGroup,
      otherInfo: {
        ...testSchedule.otherInfo,
        supervisorNotes: newNotesData,
      },
    };

    this.props.updateTestSchedule(dataObj, "updateSiteNote");
    this.closeDialog();
  }

  deleteSiteNote() {
    const { notesData, testSchedule, selectedNoteData, testScheduleGroup } = this.state;

    let newNotesData = notesData.filter((d) => d.id !== selectedNoteData.id);

    let dataObj = {
      _id: testSchedule._id,
      groupIds: testScheduleGroup,
      otherInfo: {
        ...testSchedule.otherInfo,
        supervisorNotes: newNotesData,
      },
    };

    this.props.updateTestSchedule(dataObj, "updateSiteNote");
    this.closeDialog();
  }

  closeDialog() {
    this.setState({ openAddEditSiteNotesForm: false });
  }

  render() {
    let { siteNotesFormState, openAddEditSiteNotesFormData, openAddEditSiteNotesForm, confirmationDialog, notesData } = this.state;
    let disableButtonOnInspection = this.props.inspectionData && this.props.inspectionData.status !== "Finished" ? true : false;

    return (
      <div>
        <div className="site-notes-title-section">
          <div style={{ padding: "5px", textAlign: "left", fontSize: "20px", fontWeight: 600 }}>
            <span style={{ borderBottom: "2px solid" }}>{this.props.title}</span>
          </div>
          <div className="button-section">
            {this.isUserAllowed && disableButtonOnInspection && <span className="message-section">Inspection in progress ...</span>}
            {this.isUserAllowed && (
              <button
                disabled={disableButtonOnInspection}
                className="add-button"
                onClick={() => {
                  this.handleAddEditDelete("Create");
                }}
              >
                {languageService(this.props.buttonTitle)}
              </button>
            )}
          </div>
        </div>
        <CommentSection data={notesData} getTableColumns={this.getTableColumns} getActions={this.isUserAllowed} />

        {openAddEditSiteNotesForm && (
          <CustomForm
            mode="dialog"
            currState={siteNotesFormState}
            fieldsData={openAddEditSiteNotesFormData}
            formSchema={siteNotesFormSchema}
            closeDialog={this.closeDialog}
            parentRef={{
              updateSiteNote: this.updateSiteNote,
            }}
          />
        )}
        {confirmationDialog}
      </div>
    );
  }
}
export default SiteNotes;

const CommentSection = ({ data, getTableColumns, getActions }) => {
  return (
    <div style={{ padding: "10px", textAlign: "left", border: "2px solid black", fontSize: "20px", minHeight: "200px" }}>
      <div className="no-print">
        <ThisTable
          tableColumns={getTableColumns(getActions)}
          tableData={data}
          pagination={false}
          forDashboard={false}
          height={"auto"}
          overrideRowStyle={{ minHeight: "35px", height: "auto", background: "var(--fifth)", breakInside: "avoid" }}
        />
      </div>
      <div className="site-notes-table">
        <ThisTable
          tableColumns={getTableColumns(false)}
          tableData={data}
          pagination={false}
          forDashboard={false}
          height={"auto"}
          overrideRowStyle={{ minHeight: "35px", height: "auto", background: "var(--fifth)", breakInside: "avoid" }}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/utils/SiteNotes/index.jsx